const initialStateFilters = {
  typeSelect: { id: 'Ciclo', label: 'Ciclo', text: 'Filtrar por Ciclo' },
  ciclo: { id: 1, name: 'Janeiro' },
  dataInicial: '',
  dataFinal: ''
}

const initialState = {
  projetos: [],
  projeto: {},
  benchmarkLoad: false,
  benchmarkData: null,
  benchmarkGrafico: [],
  benchmarkError: null,
  filtersProvisorio: initialStateFilters
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LIST_PROJETOS':
      return { ...state, projetos: payload }

    case 'INFO_PROJETO':
      return { ...state, projeto: payload }

    case 'LOAD_BENCHMARK':
      return { ...state, benchmarkLoad: payload }

    case 'INFO_BENCHMARK':
      return { ...state, benchmarkData: payload }

    case 'INFO_BENCHMARK_GRAFICO':
      return { ...state, benchmarkGrafico: payload }

    case 'ERROR_BENCHMARK':
      return { ...state, benchmarkError: payload }

    case 'INFO_FILTERS_BENCHMARK':
      return { ...state, filtersProvisorio: payload }

    case 'CHANGE_FILTERS_BENCHMARK':
      return {
        ...state,
        filtersProvisorio: {
          ...state.filtersProvisorio,
          [payload.name]: payload.value
        }
      }

    case 'CLEAN_FILTERS_BENCHMARK':
      return { ...state, filtersProvisorio: initialStateFilters }

    default:
      return state
  }
}